<div mat-dialog-title class="dialog-info">
    <label class="dialogTitle">
        {{'SAP_SUBMITTAL' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]></button>
</div>

<mat-dialog-content class="contentPadding d-flex flex-column justify-content-around overflow-hidden">
    <div class="dialog-content-container d-flex align-items-center">
        <!-- Left section with status icon -->
        <div class="icon-section">
            @if (isSuccess) {
                <mat-icon class="success-icon">info</mat-icon>
            } @else {
                <mat-icon class="error-icon">cancel</mat-icon>
            }
        </div>
        
        <!-- Right section with content -->
        <div class="content-section">
            @if (isSuccess) {
                <p class="dialog-paragraph">
                    {{ 'SAP_SUBMISSION_SUCCESS_MESSAGE' | translate }}
                </p>
            } @else {
                <p class="dialog-paragraph">
                    {{ 'SAP_SUBMISSION_FAILURE_MESSAGE' | translate }}
                </p>
            }
        </div>
    </div>

    <!-- Document upload results (shown only on success when opportunity was linked) -->
    @if (showDocUploadResults) {
    <div class="doc-upload-results">
        <p class="doc-upload-item" [class.upload-success]="response?.isCostReviewDocUploadSuccessfull" [class.upload-failure]="!response?.isCostReviewDocUploadSuccessfull">
            @if (response?.isCostReviewDocUploadSuccessfull) {
                <mat-icon class="doc-icon success">check_circle</mat-icon>
                <span>{{ 'SAP_SUBMISSION_DOC_COST_REVIEW_SUCCESS' | translate }}</span>
            } @else {
                <mat-icon class="doc-icon failure">cancel</mat-icon>
                <span>{{ 'SAP_SUBMISSION_DOC_COST_REVIEW_FAILURE' | translate }}</span>
            }
        </p>
        <p class="doc-upload-item" [class.upload-success]="response?.isSapSubmittalDocUploadSuccessfull" [class.upload-failure]="!response?.isSapSubmittalDocUploadSuccessfull">
            @if (response?.isSapSubmittalDocUploadSuccessfull) {
                <mat-icon class="doc-icon success">check_circle</mat-icon>
                <span>{{ 'SAP_SUBMISSION_DOC_SUBMITTAL_SUCCESS' | translate }}</span>
            } @else {
                <mat-icon class="doc-icon failure">cancel</mat-icon>
                <span>{{ 'SAP_SUBMISSION_DOC_SUBMITTAL_FAILURE' | translate }}</span>
            }
        </p>
    </div>
    }

    <!-- XML download section (for special sales offices 998/999) -->
    @if (showXmlDownload) {
    <div class="xml-download-section">
        <p class="dialog-paragraph">{{ 'SAP_SUBMISSION_XML_AVAILABLE' | translate }}</p>
        <button mat-stroked-button color="primary" (click)="downloadXml()" class="download-btn">
            <mat-icon>download</mat-icon>
            {{ 'SAP_SUBMISSION_DOWNLOAD_XML' | translate }}
        </button>
    </div>
    }
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions-style">
    <button class="openCloseBtn" mat-raised-button color="primary" mat-dialog-close>{{'OK' | translate}}</button>
</mat-dialog-actions>